import {
  MarkerClusterer,
  SuperClusterAlgorithm,
} from "@googlemaps/markerclusterer";
import { memo, useEffect, useRef, useState } from "react";

const CustomerMarkers = ({ customers, map }) => {
  const markersRef = useRef({});
  const [clusterer, setClusterer] = useState(null);

  useEffect(() => {
    if (!map || !window.google) return undefined;

    const instance = new MarkerClusterer({
      map,
      algorithm: new SuperClusterAlgorithm({ radius: 80 }),
    });
    setClusterer(instance);

    return () => {
      instance.clearMarkers();
      Object.values(markersRef.current).forEach(({ marker }) => {
        marker.map = null;
      });
      markersRef.current = {};
      setClusterer(null);
    };
  }, [map]);

  useEffect(() => {
    if (!clusterer) return;

    Object.keys(markersRef.current).forEach((id) => {
      if (customers.some((c) => c._id === id)) return;
      const { marker } = markersRef.current[id];
      clusterer.removeMarker(marker);
      marker.map = null;
      delete markersRef.current[id];
    });
  }, [customers, clusterer]);

  useEffect(() => {
    if (!map || !clusterer) return;
    if (!window.google?.maps?.marker?.AdvancedMarkerElement) return;

    customers.forEach((customer) => {
      const lat = Number(customer.location?.lat);
      const lng = Number(customer.location?.long);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

      if (!markersRef.current[customer._id]) {
        const img = document.createElement("img");
        img.style.width = "45px";
        img.src = `${process.env.REACT_APP_PUBLIC_URL}/assets/markers/customer_marker.png`;

        const marker = new window.google.maps.marker.AdvancedMarkerElement({
          position: { lat, lng },
          content: img,
          title: customer?.name || "Customer",
        });

        markersRef.current[customer._id] = { marker, img };
        clusterer.addMarker(marker);
        return;
      }

      markersRef.current[customer._id].marker.position = { lat, lng };
    });
  }, [customers, clusterer, map]);

  return null;
};

export default memo(CustomerMarkers);